import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1322788416056310';
/**
 * Inicializa el Meta Pixel (Facebook Pixel) y dispara el evento PageView.
 * Inyecta el snippet oficial de fbevents.js. No renderiza nada visible.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // Snippet oficial de Meta Pixel
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
    // <noscript> fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.body.removeChild(noscript);
    };
  }, []);
  return null;
}